import { req } from 'react-reqq-lite';

import { withAclReq } from 'modules/partial/hooks';

import * as c from './constants';
import * as t from './transformers';

const prefix = process.env.REACT_APP_MS_END_POINT;

export const getRecentTransactions = (
  { params, branch_uuid, merchant_uuid } = {},
  cb
) => {
  req.get(
    withAclReq(
      () => ({
        ADMIN: {
          url: () =>
            `${prefix}/order/v2/vendors/${merchant_uuid}/branches/${branch_uuid}/pos/recent-transactions`,
        },
        MERCHANT: {
          url: () => `${prefix}/order/v2/me/pos/recent-transactions`,
        },
        BRANCH: {
          url: () => `${prefix}/order/v2/me/pos/recent-transactions`,
        },
      }),
      {
        key: c.GET_RECENT_TRANSACTIONS,
        params,
        transform: ({ data, meta }) => ({
          data: data?.map(t.transformGetRecentTransactions),
          pagination: meta,
        }),
        onSuccess: (res) => {
          if (typeof cb === 'function') cb(res);
        },
      }
    )
  );
};

export const getSelectedRecentTransaction = (
  { params, order_uuid } = {},
  cb
) => {
  req.get(
    withAclReq(
      () => ({
        ADMIN: {
          url: `/v2/me/pos/order/${order_uuid}`,
        },
        MERCHANT: {
          url: `/v2/me/pos/order/${order_uuid}`,
        },
        BRANCH: {
          url: `/v2/me/pos/order/${order_uuid}`,
        },
      }),
      {
        key: c.GET_SELECTED_RECENT_TRANSACTION,
        params,
        transform: ({ data, included }) =>
          t.transformGetSelectedRecentTransactions(data, included),
        onSuccess: (res) => {
          if (typeof cb === 'function') cb(res);
        },
      }
    )
  );
};
